import React, { useContext } from 'react';
import { Table } from 'syngenta-digital-cropwise-react-ui-kit';
import Button from 'screens/Integrations/components/IntegrationButton';
import 'styles/uiKitTableReset.css';
import 'screens/Integrations/components/integrationTable.css';
import { mappingShape } from 'screens/Property/helpers/propertyDataHelpers';

import FieldIcon from 'components/Icons/FieldIcon';
import DeleteIcon from 'components/Icons/components/DeleteIcon';
import MapIllustration from 'assets/properties-map-icon.svg';
import FormattedNumber from 'components/FormattedNumber';
import { IntegrationsContext } from 'screens/Integrations/context/IntegrationsProvider';

const PropertyListView = () => {
  const {
    state: { selectedProperties },
    updateSelectedProperties
  } = useContext(IntegrationsContext);

  const handleDeleteProperty = propertyId => {
    const selectedPropertiesLeft = selectedProperties.filter(
      property => property.properties.id !== propertyId
    );

    updateSelectedProperties(selectedPropertiesLeft);
  };

  const columns = [
    {
      key: 'field',
      title: `Fields (${selectedProperties.length})`,
      width: '30%',
      render: (_, property) => (
        <div className="flex items-center">
          <FieldIcon id="field-card-icon" features={[mappingShape(property)]} />
          <div className="flex flex-col justify-start leading-5 text-left ml-3">
            <span className="font-bold text-neutral-1000">
              {property.properties.fieldName}
            </span>
            <span style={{ color: '#707374' }}>{property.properties.name}</span>
          </div>
        </div>
      )
    },
    {
      key: 'crop',
      title: 'Crops',
      render: (_, property) => property.properties.crop.name
    },
    {
      key: 'area',
      title: 'Area',
      render: (_, property) => (
        <>
          <FormattedNumber roundedTo={2}>
            {property.properties.reportedArea ||
              property.properties.boundaryArea}
          </FormattedNumber>{' '}
          ac
        </>
      )
    },
    {
      key: 'actions',
      render: (_, property) => (
        <div className="flex justify-end w-full pr-5">
          <Button
            variant="text"
            aria-label={`Remove ${property.properties.name}`}
            icon={
              <DeleteIcon
                color="#696F88"
                width="24"
                height="24"
                widthBox="5"
                heightBox="6"
              />
            }
            onClick={() => handleDeleteProperty(property.properties.id)}
          />
        </div>
      )
    }
  ];

  return (
    <div className="h-full w-3/4" data-testid="property-list-view">
      <div className="flex flex-col w-full h-30 font-body cwf-table-flush cwf-table-static-header cwf-table-no-row-hover integration-table">
        <Table
          rowKey={property => property.properties.id}
          columns={columns}
          dataSource={selectedProperties}
          pagination={false}
          locale={{ emptyText: null }}
        />
        {!selectedProperties.length && (
          <div
            className="flex flex-col items-center self-stretch justify-center h-full py-32 border border-t-0"
            data-testid="empty-body-table"
          >
            <img src={MapIllustration} alt="No properties illustration" />
            <p>
              Select one or more fields from the list to add it to this Plan
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyListView;
